/**
 * Shared functionality for locations specific to Storm
 */
goog.provide('yext.storm.location.util');

goog.require('yext');
goog.require('yext.location.util');

/**
 * Build localized location address including link to profile
 *
 * @param {!Object} location Location details
 * @return {string} HTML string of location address markup
 */
yext.storm.location.util.buildLocationAddress = function(location) {
  var $html = $('<div>', {
    html: $('<a>', {
      href: '/s/' + yext.businessId + '/entity/edit?entityIds=' + location.id,
      html: $('<strong>', {text: yext.storm.location.util.generateEmbeddedFieldBadges(location.name, true)}),
    }),
  }).append('<br>');

  $html.append(yext.location.util.buildLocationAddress(location));

  // Remove last break
  $html.find('br').last().remove();

  return $html.html();
};

/**
 * Takes a raw embedded field value and replaces brackets with HTML
 *
 * @param {string} raw Raw embedded field string
 * @param {boolean} small True to make the badge small
 * @return {string} String with brackets replaced by html
 */
yext.storm.location.util.generateEmbeddedFieldBadges = (function() {
  var fieldViewRe = /\[\[(.+?)\]\]/g;
  return function(raw, small) {
    raw = String(raw).replace(fieldViewRe, '<span class="badge-info' + (small ? ' badge-small' : '') + '">$1</span>');
    return raw;
  };
})();
